export default "__VITE_ASSET__49540dd1__"